// eslint-disable-next-line import/prefer-default-export
export const getLoading = state => state.loading;
